import React from 'react'
import classes from './Price.module.sass'
import { Helmet } from 'react-helmet-async'
import { Button } from '../../../common/components/button/Button'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { usePrice } from './hooks/usePrice'

export const Price = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    document,
    setDocument,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    addPrice,
    removePrice,
  } = usePrice()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Цены товаров`}</title>
        <meta name="description" content={`Управление ценами товаров`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`Цены товаров`}</div>
        <Button onClick={() => startCreate()} text="Установить цены" />
      </div>

      <List showDetails={showDetails} startEdit={startEdit} list={list} loading={loading} />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          document={document}
          setDocument={setDocument}
          getList={getList}
          setModalActive={setModalActive}
          addPrice={addPrice}
          removePrice={removePrice}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
